import {Ease} from "../core/Animatable";
import {ISignal} from "../core/Signal";
import {SlotId} from "../data/StoryModel";
import {FocusableButton} from "./FocusableButton";
import {Optionable, OptionableData} from "./Optionable";
import {SceneItem} from "./SceneItem";

export class SceneCreatorItem extends SceneItem {

    get slot(): string | undefined {
        return this._slotIds ? this._slotIds.join(" ") : undefined;
    }

    set slot(value: string | undefined) {
        this._slotIds = value ? value.split(/\s+/g) as SlotId[] : undefined;
    }

    get button(): FocusableButton | undefined {
        return this._button;
    }

    get slotIds(): SlotId[] | undefined {
        return this._slotIds;
    }

    private _button?: FocusableButton;
    private _slotIds?: SlotId[];
    private readonly onSelectSlot: ISignal<(slotId: SlotId) => void>;

    constructor(onSelectSlot: ISignal<(slotId: SlotId) => void>) {
        super();
        this.onSelectSlot = onSelectSlot;
    }

    public onLayout() {
        super.onLayout();
        if (this._slotIds && this._slotIds.length > 0) {
            let isAnimating = false;
            this._button = this.addChild(new FocusableButton());
            this._button.onClick.add(() => {
                this.onSelectSlot(this._slotIds![0]);
                if (isAnimating) {
                    return;
                }
                isAnimating = true;
                const s = 1.06;
                const bounds = this._button!.visuals.getLocalBounds();
                const dx = bounds.x + bounds.width / 2 - s * (bounds.x + bounds.width / 2);
                const dy = bounds.y + bounds.height / 2 - s * (bounds.y + bounds.height / 2);
                this._button!.visuals.tweenTo(0.2, Ease.sineInOut, {
                    repeat: 1,
                    yoyo: true,
                    scaleXY: s,
                    x: dx,
                    y: dy,
                    onUpdate: () => {
                        this.updatePaperCut();
                    },
                    onComplete: () => {
                        isAnimating = false;
                    },
                });
            });
            for (const item of this.items) {
                this._button.visuals.addChild(item);
            }
        }
    }

    protected createSceneItem(data?: OptionableData): Optionable {
        return new SceneCreatorItem(this.onSelectSlot);
    }
}
